import { ModalFooter } from 'components/modals/ModalFooter';
import { ModalHeader } from 'components/modals/ModalHeader';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStartClientIdentificationMutation } from 'store/api/client-identifications';
import { TierCode } from 'types/clientIdentification';
import { t } from 'utils/getTranslations';
import { TierRadioCards } from './TierRadioCards';

interface Props {
    party: { id: number; name: string };
    onClose: () => void;
}

/** Asks the tier and starts the client identification at it; the new draft's page opens on success. */
export function StartClientIdentificationDialog({ party, onClose }: Props) {
    const navigate = useNavigate();
    const [tierCode, setTierCode] = useState<TierCode | null>(null);
    const [start, { isLoading }] = useStartClientIdentificationMutation();

    const startAtTier = async () => {
        if (!tierCode) {
            return;
        }
        try {
            const { contractId } = await start({ partyId: party.id, tierCode }).unwrap();
            onClose();
            navigate(`/contract/${contractId}`);
        } catch {
            // The API layer has shown the server's reason; the dialog stays open.
        }
    };

    return (
        <>
            <ModalHeader title={t('client-identification.start-title')} subtitle={party.name} onCancel={onClose} />
            <div className="flex flex-col gap-4 overflow-y-auto p-6">
                <p className="m-0 font-semibold">{t('client-identification.choose-tier')}</p>
                <TierRadioCards value={tierCode} onChange={setTierCode} />
            </div>
            <ModalFooter
                onCancel={onClose}
                onSave={() => void startAtTier()}
                saveButtonTextId="client-identification.start"
                disableSave={!tierCode || isLoading}
            />
        </>
    );
}
